export default "__VITE_PUBLIC_ASSET__e8be6f70__"